import React, { useEffect } from 'react';
import ProspectsPageContent from './prospects-page.content';
import useGetFormFields from '../../network/hooks/get-form-fields.hook';

const ProspectsPage: React.FunctionComponent = () => {
  const getFormFields = useGetFormFields('client_prospects');

  useEffect(() => {
    getFormFields?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <ProspectsPageContent />;
};

export default ProspectsPage;
